import React from "react";

export const ButtonBg = ({ text, classes = "", onClick = null }) => {
  return (
    <button
      onClick={onClick}
      className={`${classes} h-12 px-6 mb-5 rounded-3xl text-white text-lg font-semibold bg-green-600 text-center`}
    >
      {text}
    </button>
  );
};
